'use strict';

import { CoreRepository } from '../CoreRepository';
import { AgencySetting } from '../../Entities/Agency/AgencySetting';
export class AgencySettingRepository extends CoreRepository {
  public updateAgencySetting(agencyId: number, payload: object = {}) {
    return this.webAPI.updateAgencySetting(agencyId, payload).then((response) => {
      const agencySetting = new AgencySetting();
      agencySetting.hydrate(response);

      return agencySetting;
    });
  }

  /*
    public getAgencyLogo(options: object = null){
        if( !options )
        {
        options = {};
        }

        return this.webAPI.getAgencyLogo(options)
        .then( response => {
            if( !response )
            {
            return false;
            }

            let AgencyLogo = new AgencyLogo();
            AgencyLogo.hydrate(response);

            return AgencyLogo;
        });
    }

    public createAgencyLogo(payload: object = {}){  
    return this.webAPI.createAgencyLogo(payload)
      .then( response => {
        let AgencyLogo = new AgencyLogo();
        AgencyLogo.hydrate(response);

        return AgencyLogo;
      });
    }

    public updateAgencyLogo(payload: object = {}){  
        return this.webAPI.updateAgencyLogo(payload)
        .then( response => {
            let AgencyLogo = new AgencyLogo();
            AgencyLogo.hydrate(response);

            return AgencyLogo;
        });
    }

    public removeAgencyLogo( ){
        return this.webAPI.removeAgencyLogo()
        .then( response => {
            return response;
        });
    }
    */
}
